"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
var _encryption = _interopRequireDefault(require("../encryption"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // src/tal.js
var TAL = exports["default"] = /*#__PURE__*/function (_Core) {
  function TAL(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TAL);
    _this = _callSuper(this, TAL, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.services = props.services;
    _this.cryptoKey = props.cryptoKey;
    _this.publicKey = props.publicKey;
    _this.myServices = ["dpm"];
    _this.ready = false;
    _this._events = {};
    _this.on = _this.on.bind(_this);
    _this.handleMessages = _this.handleMessages.bind(_this);
    _this.init();
    return _this;
  }

  // Helper: nanosecond timestamp
  (0, _inherits2["default"])(TAL, _Core);
  return (0, _createClass2["default"])(TAL, [{
    key: "generateTimestamp",
    value: function generateTimestamp() {
      return Number(BigInt(Date.now()) * 1000000n);
    }
  }, {
    key: "detectServices",
    value: function detectServices() {
      var _this2 = this;
      return Object.keys(this.services).some(function (key) {
        return _this2.myServices.includes(key);
      });
    }
  }, {
    key: "sendCommand",
    value: function () {
      var _sendCommand = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(command) {
        var params,
          uuid,
          origin,
          timestamp,
          payload,
          _args = arguments;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              uuid = (0, _uuid.v4)();
              origin = "sdk-".concat(this.appName);
              timestamp = this.generateTimestamp();
              _context.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services.dpm, {
                command: command,
                params: params
              }, uuid, origin, timestamp);
            case 1:
              payload = _context.sent;
              _context.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              return _context.abrupt("return", this.waitForResponse(command, uuid, this.services.dpm));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function sendCommand(_x) {
        return _sendCommand.apply(this, arguments);
      }
      return sendCommand;
    }() // Exposed methods
  }, {
    key: "TALUnlock",
    value: function () {
      var _TALUnlock = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.sendCommand("System.PeripheralsManager.TALUnlock", {}));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function TALUnlock() {
        return _TALUnlock.apply(this, arguments);
      }
      return TALUnlock;
    }()
  }, {
    key: "TALGetHoldTime",
    value: function () {
      var _TALGetHoldTime = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.sendCommand("System.PeripheralsManager.TALGetHoldTime", {}));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function TALGetHoldTime() {
        return _TALGetHoldTime.apply(this, arguments);
      }
      return TALGetHoldTime;
    }()
  }, {
    key: "TALSetHoldTime",
    value: function () {
      var _TALSetHoldTime = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(holdTime) {
        var uuid, origin, timestamp, command, payload;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              uuid = (0, _uuid.v4)();
              origin = "sdk-".concat(this.appName);
              timestamp = this.generateTimestamp();
              command = "System.PeripheralsManager.TALSetHoldTime";
              _context4.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: command,
                params: {
                  hold_time: Number(holdTime)
                }
              }, uuid, origin, timestamp);
            case 1:
              payload = _context4.sent;
              _context4.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              return _context4.abrupt("return", this.waitForResponse(command, uuid, this.services.dpm));
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function TALSetHoldTime(_x2) {
        return _TALSetHoldTime.apply(this, arguments);
      }
      return TALSetHoldTime;
    }()
  }, {
    key: "TALEnable",
    value: function () {
      var _TALEnable = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.sendCommand("System.PeripheralsManager.TALEnable", {}));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function TALEnable() {
        return _TALEnable.apply(this, arguments);
      }
      return TALEnable;
    }()
  }, {
    key: "TALDisable",
    value: function () {
      var _TALDisable = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        return _regenerator["default"].wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.sendCommand("System.PeripheralsManager.TALDisable", {}));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function TALDisable() {
        return _TALDisable.apply(this, arguments);
      }
      return TALDisable;
    }()
  }, {
    key: "waitForResponse",
    value: function () {
      var _waitForResponse = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(command, uuid, service) {
        var _this3 = this;
        return _regenerator["default"].wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", new Promise(function (resolve, reject) {
                _this3.connection.on("messaging", /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(msg) {
                    var decrypted, obj, err, _t;
                    return _regenerator["default"].wrap(function (_context7) {
                      while (1) switch (_context7.prev = _context7.next) {
                        case 0:
                          if (!(msg.action === "System.SDK.ServiceCall" && msg.requestUuid === uuid)) {
                            _context7.next = 5;
                            break;
                          }
                          _context7.prev = 1;
                          _context7.next = 2;
                          return _encryption["default"].decryptSymmetrically(service, msg.data);
                        case 2:
                          decrypted = _context7.sent;
                          obj = JSON.parse(decrypted);
                          if (!(obj.response && obj.response.success === false)) {
                            _context7.next = 3;
                            break;
                          }
                          err = new Error(obj.response.message || 'Error from TAL');
                          err.code = command;
                          _logger["default"].error("TAL Error", err.message, "TAL");
                          return _context7.abrupt("return", reject(err));
                        case 3:
                          resolve(obj.params !== undefined ? obj.params : obj);
                          _context7.next = 5;
                          break;
                        case 4:
                          _context7.prev = 4;
                          _t = _context7["catch"](1);
                          _logger["default"].error("TAL Decrypt Error", _t.message, "TAL");
                          reject(new Error('Failed to decrypt TAL response'));
                        case 5:
                        case "end":
                          return _context7.stop();
                      }
                    }, _callee7, null, [[1, 4]]);
                  }));
                  return function (_x6) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }));
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function waitForResponse(_x3, _x4, _x5) {
        return _waitForResponse.apply(this, arguments);
      }
      return waitForResponse;
    }()
  }, {
    key: "handleMessages",
    value: function handleMessages(message) {
      if (message.origin === "sdk-".concat(this.appName)) return;
      switch (message.action) {
        case "System.PeripheralsManager.Notify.Ready":
          // handle ready notification if needed
          if (!this.ready) {
            this.ready = true;
            this.trigger("ready", true);
            _logger["default"].success("Initialization", "Module is now fully ready", "Tal");
          }
          break;
        default:
          break;
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this4 = this;
      _logger["default"].info("TAL", "Initializing TAL module", "TAL");
      if (!this.detectServices()) {
        _logger["default"].warn("TAL", "DPM service not found yet", "TAL");
      }
      this.connection.on("messaging", this.handleMessages);
      setTimeout(function () {
        _this4.getCheckReady();
      }, 3000);
    }
  }, {
    key: "getCheckReady",
    value: function () {
      var _getCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9() {
        var payload, _t2;
        return _regenerator["default"].wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              payload = {
                action: "System.PeripheralsManager.CheckReady",
                uuid: (0, _uuid.v4)(),
                origin: "sdk-" + this.appName,
                request_uuid: "",
                timestamp: this.generateTimestamp(),
                data: "{}"
              };
              _context9.next = 1;
              return this.connection.invoke("messaging", payload);
            case 1:
              _logger["default"].info("Check Ready", "Checking if everything is ready", "Tal");
              _context9.next = 3;
              break;
            case 2:
              _context9.prev = 2;
              _t2 = _context9["catch"](0);
              console.error("Error in getCheckReady:", _t2);
              throw _t2;
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[0, 2]]);
      }));
      function getCheckReady() {
        return _getCheckReady.apply(this, arguments);
      }
      return getCheckReady;
    }()
  }]);
}(_core["default"]);